<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
      </div>
      <div class="company-box">
        <div class="company">
          <el-link href="https://www.100ec.cn/Index/wjs_search_res.html?kw=微信" target="_blank">
           微信
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=小红书" target="_blank">
           小红书
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=抖音" target="_blank">
           抖音
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=快手" target="_blank">
           快手
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=哔哩哔哩" target="_blank">
           哔哩哔哩
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=鲸灵集团" target="_blank">
           鲸灵集团
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=快团团" target="_blank">
           快团团
          </el-link>
          <el-link href="https://www.100ec.cn/Index/wjs_search_res.html?kw=蜂享家" target="_blank">
           蜂享家
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=好衣库" target="_blank">
           好衣库
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=全球家精选" target="_blank">
           全球家精选
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=粉象生活" target="_blank">
           粉象生活
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=微盟" target="_blank">
           微盟
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=有赞" target="_blank">
            有赞
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=微店" target="_blank">
            微店
          </el-link>
          <el-link href="https://www.100ec.cn/enterprise/#/Inside?name=魔筷科技" target="_blank">
           魔筷科技
          </el-link>
        </div>
      </div>
    </div>
    <Email />
    <div style="width: 365px">
      <a> 
        
      </a>
      <img style="width: 100%" src="//imgs-b2b.100ec.cn/Public/Upload/image/20260105/1767598143395920.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      activeName: "fourth",
    };
  },
  // created() {
  //   this.$store.commit("getCompanyTabs", this.params);
  // },
};
</script>
<style scoped>
.partner-list li {
    padding: 10px;
    flex: 0 0 20%;
}
.partner-list img {
    width: 106px;
    border-radius: 2px;
    opacity: 1;
    transition: all .3s ease;
}
.platform a{
  color: #111;
}
.platform a:hover{
  color: #fff;
}
</style>